import React from 'react'

import { ZariContext } from '_zari/context'
import { AdminContext } from 'contexts/AdminContext'

import { Col, Row, Card } from '_zari/core'

import { LadosIsla } from 'constants/index'

import * as IslaCombustible from 'services/islaCombustible.service'

import OpcionCombustible from './opcionCombustible'

import * as ProductoService from 'services/producto.service'

const CombustiblesxIslaSection = ({
  modalidadCalculo,
  datosCombustibleEnUso,
  setDatosCombustibleEnUso,
  ladoSeleccionado,
  setFieldValue,
  idListaPrecio,
  handleSubmit,
  flagEdicion
}) => {
  const __zariContext = React.useContext(ZariContext)
  const __adminContext = React.useContext(AdminContext)

  const esEdicion = React.useRef(datosCombustibleEnUso)

  const [combustibleSeleccionado, setCombustibleSeleccionado] = React.useState('')

  const [combustiblesLado1, setCombustiblesLado1] = React.useState([])
  const [combustiblesLado2, setCombustiblesLado2] = React.useState([])

  const [arrCombustibles, setArrCombustibles] = React.useState([])

  React.useEffect(() => {
    IslaCombustible.obtenerAsSelfVenta(__adminContext._idIslaActiva, idListaPrecio)
      .then(({ data }) => {
        if (!data) {
          data = []
        }

        const itemsLado1 = data.filter(x => x.lado === LadosIsla.Lado1)
        const itemsLado2 = data.filter(x => x.lado === LadosIsla.Lado2)

        setCombustiblesLado1(itemsLado1)
        setCombustiblesLado2(itemsLado2)

        if (esEdicion.current._idProducto) {
          const matchProducto = data.find(z => z._idProducto === esEdicion.current._idProducto)
          setCombustibleSeleccionado(matchProducto.combustible)
        } else {
          if (itemsLado1.length > 0) {
            setCombustibleSeleccionado(itemsLado1[0].combustible)
          } else if (itemsLado2.length > 0) {
            setCombustibleSeleccionado(itemsLado2[0].combustible)
          }
        }
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [idListaPrecio, __zariContext, __adminContext._idIslaActiva])

  React.useEffect(() => {
    ProductoService.obtenerAsCombustibles().then(({ data }) => {
      setArrCombustibles(data)
    })
  }, [])

  return (
    <>
      {arrCombustibles.length && (
        <Row>
          <Col md={6}>
            <Card>
              <Card.Header>LADO 1</Card.Header>
              <Card.Body>
                {combustiblesLado1.map((x, k) => (
                  <OpcionCombustible
                    key={k}
                    arrCombustibles={arrCombustibles}
                    infoCombustiblexIsla={x}
                    ladoSeleccionado={ladoSeleccionado}
                    combustibleSeleccionado={combustibleSeleccionado}
                    setCombustibleSeleccionado={setCombustibleSeleccionado}
                    modalidadCalculo={modalidadCalculo}
                    datosCombustibleEnUso={datosCombustibleEnUso}
                    setDatosCombustibleEnUso={setDatosCombustibleEnUso}
                    setFieldValue={setFieldValue}
                    handleSubmit={handleSubmit}
                    flagEdicion={flagEdicion}
                  />
                ))}
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>
            <Card>
              <Card.Header>LADO 2</Card.Header>
              <Card.Body>
                {combustiblesLado2.map((x, k) => (
                  <OpcionCombustible
                    key={k}
                    arrCombustibles={arrCombustibles}
                    infoCombustiblexIsla={x}
                    ladoSeleccionado={ladoSeleccionado}
                    combustibleSeleccionado={combustibleSeleccionado}
                    setCombustibleSeleccionado={setCombustibleSeleccionado}
                    modalidadCalculo={modalidadCalculo}
                    datosCombustibleEnUso={datosCombustibleEnUso}
                    setDatosCombustibleEnUso={setDatosCombustibleEnUso}
                    setFieldValue={setFieldValue}
                    handleSubmit={handleSubmit}
                    flagEdicion={flagEdicion}
                  />
                ))}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}
    </>
  )
}

export default React.memo(CombustiblesxIslaSection)
